module.exports = __webpack_public_path__ + "static/media/backgroundTop.e9c5cbe9.png";